(function ($) {
    $(document).on('ready',function () {
        wrapFirstWord();
        animationPinned();
    });

    function wrapFirstWord() {
        const parent = $('.preview_buildings .preview_buildings_wrap .building');
        const string = parent.find('h4');

        string.each(function(){
            var me = $(this);
            me.html(me.html().replace(/^(\w+)/, '<span>$1</span>'));
        });
    }

    function animationPinned() {
        let building = $(".preview_buildings");
        let building1 = $(".preview_buildings .building:first-child");
        let building2 = $(".preview_buildings .building:last-child");

        if (globalVar.is_desktop && building1.length !== 0 && building2.length ) {
            gsap.from( building1, {
                x: "50%",
                autoAlpha: 0,
                transformOrigin: "top",
                scrollTrigger: {
                    trigger: building,
                    start: "top bottom",
                    end: "top center",
                    scrub: true,
                }
            });

            gsap.from( building2, {
                x: "-50%",
                autoAlpha: 0,
                transformOrigin: "top",
                scrollTrigger: {
                    trigger: building,
                    start: "top bottom",
                    end: "top center",
                    scrub: true,
                }
            });
        }
    }
}(jQuery));
